import {Utilities} from '@shared/utilities/utilities.model';

export class VehicleAccessoriesModel{
    alloyWheels: boolean;
    bolt: boolean;
    cd: boolean;
    coverCircles: boolean;
    fireExtinguisher: boolean;
    frontMats: boolean;
    kitWheel: boolean;
    lighter: boolean;
    rearMats: boolean;
    ski: boolean;
    snowChains: boolean;
    stereo: boolean;
    telephoneSystem: boolean;
    triangle: boolean;
    wheel: boolean;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.alloyWheels = model.alloy_wheels;
            this.bolt = model.bolt;
            this.cd = model.cd;
            this.coverCircles = model.cover_circles;
            this.fireExtinguisher = model.fire_extinguisher;
            this.frontMats = model.front_mats;
            this.kitWheel = model.kit_wheel;
            this.lighter = model.lighter;
            this.rearMats = model.rear_mats;
            this.ski = model.ski;
            this.snowChains = model.snow_chains;
            this.stereo = model.stereo;
            this.telephoneSystem = model.telephone_system;
            this.triangle = model.triangle;
            this.wheel = model.wheel;
        } else {
            this.alloyWheels = false;
            this.bolt = false;
            this.cd = false;
            this.coverCircles = false;
            this.fireExtinguisher = false;
            this.frontMats = false;
            this.kitWheel = false;
            this.lighter = false;
            this.rearMats = false;
            this.ski = false;
            this.snowChains = false;
            this.stereo = false;
            this.telephoneSystem = false;
            this.triangle = false;
            this.wheel = false;
        }
    }
}

export class VehicleAccessoriesRequestModel {
    alloy_wheels: boolean;
    bolt: boolean;
    cd: boolean;
    cover_circles: boolean;
    fire_extinguisher: boolean;
    front_mats: boolean;
    kit_wheel: boolean;
    lighter: boolean;
    rear_mats: boolean;
    ski: boolean;
    snow_chains: boolean;
    stereo: boolean;
    telephone_system: boolean;
    triangle: boolean;
    wheel: boolean;

    constructor(model?: VehicleAccessoriesModel) {
        if (!Utilities.isVoid(model)) {
            this.alloy_wheels = model.alloyWheels;
            this.bolt = model.bolt;
            this.cd = model.cd;
            this.cover_circles = model.coverCircles;
            this.fire_extinguisher = model.fireExtinguisher;
            this.front_mats = model.frontMats;
            this.kit_wheel = model.kitWheel;
            this.lighter = model.lighter;
            this.rear_mats = model.rearMats;
            this.ski = model.ski;
            this.snow_chains = model.snowChains;
            this.stereo = model.stereo;
            this.telephone_system = model.telephoneSystem;
            this.triangle = model.triangle;
            this.wheel = model.wheel;
        } else {
            this.alloy_wheels = false;
            this.bolt = false;
            this.cd = false;
            this.cover_circles = false;
            this.fire_extinguisher = false;
            this.front_mats = false;
            this.kit_wheel = false;
            this.lighter = false;
            this.rear_mats = false;
            this.ski = false;
            this.snow_chains = false;
            this.stereo = false;
            this.telephone_system = false;
            this.triangle = false;
            this.wheel = false;
        }
    }
}
